var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"mc-list-header"},[_c('PageHeader',{staticClass:"mc-page-three",attrs:{"title":_vm.title,"items":_vm.items}})],1),_c('div',{staticClass:"mc-liveview clearfix"},[_c('GoogleMap'),_c('SideBar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }